
































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import UiSelect2 from '../ui/UiSelect2.vue';
import UiTextEdit from '../ui/UiTextEdit.vue';

export interface MetadataConditionValue {
  operator: string;
  metadata: Array<{ key: string; value: string }>;
}

@Component({ components: { UiSelect2, UiTextEdit } })
export default class MetadataConditionInput extends Vue {
  @Prop({ required: true }) readonly value!: MetadataConditionValue;

  readonly operators = [
    { id: 'OR', label: 'OR — any condition' },
    { id: 'AND', label: 'AND — all conditions' },
    { id: 'NOR', label: 'NOR' },
    { id: 'NAND', label: 'NAND' },
    { id: 'XOR', label: 'XOR — exactly one condition' },
  ];

  get localValue() {
    return this.value;
  }

  add() {
    this.localValue.metadata.push({ key: '', value: '' });
    this.emitValue();
  }

  remove(index: number) {
    if (this.localValue.metadata.length > 1) this.localValue.metadata.splice(index, 1);
    this.emitValue();
  }

  emitValue() {
    this.$emit('input', this.localValue);
  }
}
